import { render, staticRenderFns } from "./TeamMembershipsCard.vue?vue&type=template&id=fe48e022&scoped=true"
import script from "./TeamMembershipsCard.vue?vue&type=script&lang=js"
export * from "./TeamMembershipsCard.vue?vue&type=script&lang=js"
import style0 from "./TeamMembershipsCard.vue?vue&type=style&index=0&id=fe48e022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe48e022",
  null
  
)

export default component.exports